import React from 'react';
import { Link } from 'react-router-dom';

const Blog: React.FC = () => {
  const posts = [
    {
      id: 1,
      titulo: 'Como escolher o cavalo ideal para sua propriedade',
      resumo: 'Dicas essenciais para avaliar temperamento, saúde e histórico antes de comprar.',
      imagem: '🐎',
      categoria: 'Dicas',
      data: '08 Fev 2026',
      leitura: '5 min',
    },
    {
      id: 2,
      titulo: 'Tendências do mercado de equinos em 2026',
      resumo: 'Análise das principais movimentações e previsões para o setor este ano.',
      imagem: '📈',
      categoria: 'Mercado',
      data: '05 Fev 2026',
      leitura: '8 min',
    },
    {
      id: 3,
      titulo: 'Cuidados essenciais na vacinação de bovinos',
      resumo: 'Calendário completo e melhores práticas para manter seu rebanho saudável.',
      imagem: '💉',
      categoria: 'Saúde',
      data: '01 Fev 2026',
      leitura: '6 min',
    },
    {
      id: 4,
      titulo: 'Guia completo de documentação para venda de animais',
      resumo: 'Todos os documentos necessários para uma transação legal e segura.',
      imagem: '📄',
      categoria: 'Legal',
      data: '28 Jan 2026',
      leitura: '7 min',
    },
    {
      id: 5,
      titulo: 'Nutrição equina: o que seu cavalo realmente precisa',
      resumo: 'Entenda as necessidades nutricionais e monte a dieta ideal.',
      imagem: '🌾',
      categoria: 'Nutrição',
      data: '25 Jan 2026',
      leitura: '10 min',
    },
    {
      id: 6,
      titulo: 'Prepare seu haras para temporada de vendas',
      resumo: 'Estratégias para aumentar suas vendas e atrair mais compradores.',
      imagem: '🏆',
      categoria: 'Vendas',
      data: '20 Jan 2026',
      leitura: '6 min',
    },
  ];

  const categorias = ['Todas', 'Dicas', 'Mercado', 'Saúde', 'Legal', 'Nutrição', 'Vendas'];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <div className="bg-gradient-to-br from-green-700 to-green-900 text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Blog BOILX</h1>
          <p className="text-xl text-green-100 max-w-2xl mx-auto">
            Conteúdo exclusivo sobre o mundo do agronegócio, criação e mercado de animais.
          </p>
        </div>
      </div>

      <div className="container-custom py-12">
        {/* Categories */}
        <div className="flex flex-wrap gap-2 justify-center mb-12">
          {categorias.map((cat) => (
            <button
              key={cat}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                cat === 'Todas'
                  ? 'bg-green-700 text-white'
                  : 'bg-white text-gray-600 hover:bg-green-50 hover:text-green-700'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Posts Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post) => (
            <article key={post.id} className="bg-white rounded-2xl shadow-sm overflow-hidden hover:shadow-md transition-shadow">
              <div className="h-48 bg-gradient-to-br from-green-100 to-green-200 flex items-center justify-center text-6xl">
                {post.imagem}
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2 py-1 bg-green-100 text-green-700 text-xs font-semibold rounded">
                    {post.categoria}
                  </span>
                  <span className="text-gray-400 text-sm">{post.data}</span>
                </div>
                <h2 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">
                  {post.titulo}
                </h2>
                <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                  {post.resumo}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-gray-400 text-sm">⏱️ {post.leitura} de leitura</span>
                  <button className="text-green-700 font-semibold text-sm hover:underline">
                    Ler mais →
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Load More */}
        <div className="text-center mt-12">
          <button className="px-8 py-3 border-2 border-green-700 text-green-700 rounded-lg font-semibold hover:bg-green-50 transition-colors">
            Carregar Mais Artigos
          </button>
        </div>

        {/* Newsletter */}
        <div className="max-w-2xl mx-auto mt-16">
          <div className="bg-green-700 rounded-2xl p-8 text-center text-white">
            <h3 className="text-2xl font-bold mb-2">Receba novidades por e-mail</h3>
            <p className="text-green-100 mb-6">
              Assine nossa newsletter e receba conteúdo exclusivo toda semana.
            </p>
            <form className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="Seu melhor e-mail"
                className="flex-1 px-4 py-3 rounded-lg text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-green-500 focus:outline-none"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-amber-500 text-white rounded-lg font-semibold hover:bg-amber-600 transition-colors"
              >
                Assinar
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
